import { Platform, StyleSheet } from 'react-native';

export const deckPaneStyles = StyleSheet.create({
  pane: {
    height: '100%',
    minHeight: 0,
    borderWidth: 1,
    borderRadius: 16,
    overflow: 'hidden',
    flexShrink: 0,
    flexDirection: 'column',
    ...(Platform.OS === 'web' ? {
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.025)',
      transition: 'opacity 0.2s ease, width 0.2s ease',
    } : {}),
  },
});
